import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { UserMenuService } from './user-menu-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserMenuComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  islogoutOfAllSessions: boolean = false;
  agencyName: string;
  OnboardUserName: string

  old_password: any;
  new_password: any;
  confirm_password: any;
  submittedPassword: boolean = false
  passwordMatch: boolean = false
  passerror: boolean = false;
  agencys: any = {};
  get validationPass() { return this.PasswordForm.controls; }
  newpwd: string = ''
  oldpwd: string = ''
  newpwd1: string = ''
  PasswordForm: FormGroup;
  constructor(private formBuilder: FormBuilder,public global: GlobalComponent, private router: Router, public Usermenuservice: UserMenuService,
    public http: HttpClient, public toasterService: ToastrService) { }

  ngOnInit() {

    let userNames = localStorage.getItem("CFSS_Username");
    let roles = localStorage.getItem("CFSS_roles");
    if (userNames != null) {
      this.global.logginedUserName = userNames;
      this.global.globalroleName = roles;
    }
    if(roles==null || roles==undefined ||roles=='')
      {
        let agencyCode = localStorage.getItem("CFSS_agencyCode")
        this.global.globalroleName = agencyCode;
      }

    if (this.global.OnboardingLoginType == "onboardLogin") {
      this.global.onboardUserName = localStorage.getItem("CFSS_onboardusername");
      this.global.onboardRoles = localStorage.getItem("CFSS_OnboardLoginType")
      this.OnboardUserName = localStorage.getItem("CFSS_OnboardLoginUserName")



    }
    let agencydetails = JSON.parse(localStorage.getItem("CFSS_globalagencydetails"));

    if (agencydetails != null) {
      this.agencyName = agencydetails.agencyName;
      this.global.globalAgencyName = agencydetails.agencyName
      this.global.globalAgencyDropdown = agencydetails.agencyId
    }

    
    this.updatePasswordForm();
  }
  clearBoolean() {

    if (this.global.OnboardingLoginType == "onboardLogin") {
      this.islogoutOfAllSessions = true;
    }
    else {
      this.islogoutOfAllSessions = false;
    }
  }
  routeToActiveSession() {
    this.islogoutOfAllSessions = false;
    this.router.navigateByUrl("/active-session");
  }
  logoutSession() {
    if (this.islogoutOfAllSessions == true) {
      this.islogoutOfAllSessions = true;
    }
    else {
      this.islogoutOfAllSessions = false;
    }
    if (this.global.OnboardingLoginType == "agencyLogin") {
      this.Usermenuservice.logoutSession(this.islogoutOfAllSessions).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toasterService.success('Logout Successful');
         console.log("logout from cfss")
        window.postMessage("stop", "*");
        this.global.LogoutFunction();
      },
        (err: HttpErrorResponse) => {
          this.global.LogoutFunction();
        })
    }
    else if (this.global.OnboardingLoginType == "onboardLogin") {

      this.toasterService.success('Logout Successful');
      this.global.LogoutFunction();

    }
  }

// .........................................passvalid.........................................
passvalid(event) {
  let str = event.target.value;
  let res;

  if (str.match(/[a-z]/g) && str.match(
    /[A-Z]/g) && str.match(
      /[0-9]/g) && str.match(
        /[^a-zA-Z\d]/g) && str.length >= 8) {
    this.passerror = false;
  }
  else {
    this.passerror = true;
  }



}

  //................................................ ChangePasswordclient................................................
  ChangePasswordclient(old_password, newPass) {
    let params = new URLSearchParams();
    let url = "api/Client/changePassword?";

    // params.append("LoginuserId", this.decodedToken.LOGINENTITYID)
    params.append("oldPass", old_password);
    params.append("newPass", newPass);
    return this.http.get(url + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toasterService.success("Password Changed Successfully")
        setTimeout(() => {

          this.toasterService.clear()

        }, 8000);
        document.getElementById('openandcloseChangePasswordModal').click();
        this.reset();
      }

    }, (err: HttpErrorResponse) => {
      this.toasterService.error(err.error);
    });

  }

  // ........................................................employee.................................................................
  ChangePasswordEmployee(old_password, newPass) {
    let params = new URLSearchParams();
    let url1 = "api/Employee/changePassword?";

    //params.append("LoginuserId",this.decodedToken.LOGINENTITYID)
    params.append("oldPass", old_password);
    params.append("newPass", newPass);
    return this.http.get(url1 + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toasterService.success("Password Changed Successfully")
        setTimeout(() => {

          this.toasterService.clear()

        }, 8000);
        document.getElementById('openandcloseChangePasswordModal').click();
        this.reset();
      }

    }, (err: HttpErrorResponse) => {
      this.toasterService.error(err.error);
    });

  }
  // .........................................................agencyuser.......................................................................

  ChangeAgencyPassword(old_password, newPass) {
    let params = new URLSearchParams();
    let url = "api/User/changePassword?";

    //params.append("LoginuserId",this.decodedToken.LOGINENTITYID)
    params.append("oldPass", old_password);
    params.append("newPass", newPass);
    return this.http.get(url + params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data) {
        this.toasterService.success("Password Changed Successfully")
        document.getElementById('openandcloseChangePasswordModal').click();
        this.reset();
      }

    }, (err: HttpErrorResponse) => {
      this.toasterService.error(err.error);
    });

  }

    // ............................................change password................................................................//
    updatePasswordForm() {
      this.PasswordForm = this.formBuilder.group({
        old_password: ['', Validators.required],
        newPass: ['', [Validators.required, Validators.minLength(6)]],
        confirmPass: ['', Validators.required],
      })
  
    }
    // ......................................................onboardclient...................................................................................
    UpdatePassword() {
      if (this.newpwd === this.newpwd1) {
        this.passwordMatch = false;
      } else {
        this.passwordMatch = true;
      }
  
      if (this.PasswordForm.invalid || this.passwordMatch == true) {
        if (this.PasswordForm.invalid) {
          this.submittedPassword = true;
        }
        return;
      }
      this.passwordMatch = false
  
      let OnboardUserType = localStorage.getItem("CFSS_OnboardLoginType");
  
      if (OnboardUserType == "CLIENT") {
  
        this.ChangePasswordclient(this.oldpwd, this.newpwd1);
  
      }
      else if (OnboardUserType == "EMPLOYEE") {
        this.ChangePasswordEmployee(this.oldpwd, this.newpwd1);
      }
  
      else {
        this.ChangeAgencyPassword(this.oldpwd, this.newpwd1);
      }
    }
  
    reset() {
      this.PasswordForm.reset()
    }
  
    clear_pass() {
      this.PasswordForm.reset()
      this.passwordMatch = false;
      this.submittedPassword = false;
    }
}